import {
  Banned,
  LoginSessionExpired,
  UserNotFound,
  DailyBonus,
  PWA,
  WheresMyCode,
  VipBonus,
} from 'components/modals';

const modals = {
  banned: {
    header: { title: 'Oops!\nSomething went wrong', color: '#e14848' },
    component: Banned,
  },
  loginSessionExpired: {
    header: { title: 'Login Session Expired', color: '#48a2e1' },
    component: LoginSessionExpired,
  },
  userNotFound: {
    header: { title: `Seems like we can't find you`, color: '#e14848' },
    component: UserNotFound,
  },
  dailyBonus: {
    header: { title: 'Your daily bonus', color: '#f0255d' },
    component: DailyBonus,
  },
  pwa: {
    component: PWA,
    allowClose: true,
  },
  WheresMyCode: {
    component: WheresMyCode,
    allowClose: true,
  },
  vipBonus: {
    header: { title: 'Your VIP bonus', color: '#8B4513' },
    component: VipBonus,
  },
};

export default modals;
